import React from 'react';
import {I18n} from 'react-redux-i18n';
import {get} from 'lodash';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import SubscriptionTypes from '../SubscriptionTypes';

export default class SubscriptionPanel extends React.Component {

  state = {
    selectedSubscriptionType: SubscriptionTypes.NOT_SUBSCRIBED,
    userChanged: false
  }

  componentDidMount() {
    this.props.getCurrentSubscription();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.healthSubscription.loading) {
      return;
    }

    const selectedSubscriptionType = this.getCurrentSubscription(newProps);
    this.setSelectedSubscriptionType(selectedSubscriptionType);
  }

  handleChangeChangeSubscription = event => {
    const subscriptionKey = get(event, 'target.value');
    const selectedSubscriptionType = SubscriptionTypes.get(subscriptionKey);

    this.setSelectedSubscriptionType(selectedSubscriptionType);
  }

  handleSubscribeClick = () => {
    const {selectedSubscriptionType} = this.state;

    if (selectedSubscriptionType.isUnsubscription()) {
      this.props.unsubscribeForUpdates();
      return;
    }

    this.props.subscribeForUpdates({
      email: this.props.userEmail,
      subscriptionType: selectedSubscriptionType
    });
  }

  setSelectedSubscriptionType(selectedSubscriptionType) {
    const currentSubscription = this.getCurrentSubscription();
    const userChanged = currentSubscription !== selectedSubscriptionType;

    this.setState({selectedSubscriptionType, userChanged});
  }

  getCurrentSubscription(props = this.props) {
    return get(props, 'healthSubscription.current', {});
  }

  render() {
    const currentSubscription = this.getCurrentSubscription();
    const {loading} = this.props.healthSubscription;
    const {selectedSubscriptionType, userChanged} = this.state;

    const subscriptionTypes = SubscriptionTypes.all();

    return (
      <React.Fragment>
        <FormControl className="dvrcard__subscription-select">
          <InputLabel
            htmlFor="subscribeForUpdates"
            shrink={true}
            className="dvrcard__subscribe-label"
          >
            {I18n.t('page.dvrHealth.subscriptionPanel.label')}
          </InputLabel>

          <Select
            id="subscribeForUpdates"
            MenuProps={{id: 'subscribeForUpdatesMenu'}}
            onChange={this.handleChangeChangeSubscription}
            value={selectedSubscriptionType.type}
            disabled={loading}
          >
            {subscriptionTypes.map(subscriptionType => (
              <MenuItem
                id={subscriptionType.type}
                key={subscriptionType.type}
                value={subscriptionType.type}
              >
                {subscriptionType.name}
              </MenuItem>
            ))}
          </Select>

          {!loading && !userChanged && selectedSubscriptionType.isSubscription() &&
            <FormHelperText style={{color: 'green'}}>
              {I18n.t('page.dvrHealth.subscriptionPanel.subscriptionConfirmationText')}
            </FormHelperText>
          }
        </FormControl>

        <Button
          id="subscriveForUpdatesButton"
          className="btn btn-primary reports__filter-bt"
          onClick={this.handleSubscribeClick}
          disabled={loading || !userChanged}
        >
          {loading && (
            <CircularProgress className="loading__cirgularprogress" size={25} />
          )}

          {!loading && I18n.t('page.dvrHealth.subscriptionPanel.buttonLabel')}
        </Button>
      </React.Fragment>
    );
  }

}
